import React, { Component } from "react";
import DatePicker from "react-datepicker";
import { addDays } from "date-fns";

import "react-datepicker/dist/react-datepicker.css";

class DateTimePicker extends Component {
  render() {
    const { newDate, setDate } = this.props;
    const popperModifiers = [
      {
        name: "leftRoomOffset",
        // react-datepicker@9 expects Floating UI middleware with `fn`.
        // Shift x by +23 so an observed -13px becomes roughly +10px.
        fn: (state) => ({
          ...state,
          x: state.x + 23,
        }),
      },
      {
        name: "leftViewportPadding",
        // Ensure at least 10px from the viewport's left edge.
        fn: (state) => ({
          ...state,
          x: Math.max(state.x, 10),
        }),
      },
    ];

    return (
      <div>
        <DatePicker
          selected={setDate}
          className="select-new"
          id="date-picker"
          onChange={(date) => {
            newDate(date);
          }}
          timeInputLabel="Time:"
          dateFormat="MMM d, yyyy h:mm aa"
          maxDate={addDays(new Date(), 0)}
          showTimeInput
          popperModifiers={popperModifiers}
        />
      </div>
    );
  }
}

export default DateTimePicker;